var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"anchor-app-extra":""}},[_c('anchor-popup',{staticStyle:{"z-index":"204 !important"}}),_c('vue-snotify')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }